module.exports = __webpack_public_path__ + "media/images/imprimir-471eb9a8bbcf64d40ccb69f1ca63718f.svg";